export const MAX_UPLOAD_FILE_SIZE_BYTES = 10 * 1024 * 1024;
export const MAX_UPLOAD_FILE_SIZE_LABEL = "10 MB";

export const isFileTooLarge = (file) =>
  Boolean(file && file.size > MAX_UPLOAD_FILE_SIZE_BYTES);

export const getFileTooLargeMessage = () =>
  `Fajl je prevelik. Maksimalna dozvoljena veličina je ${MAX_UPLOAD_FILE_SIZE_LABEL}.`;
